import { makeHasEnded } from '@/competitions/_common/utils.ts';

import { JANUARY_OPEN_2025_CAMPAIGN_END_DATE } from '../../../config.ts';

export const useHasEnded = makeHasEnded(JANUARY_OPEN_2025_CAMPAIGN_END_DATE);
